import React from "react";
import "./SemiPlannedMarketing.css";

const mainCardData = {
  title: "기본홍보",
  subtitle: "보도자료, SNS 마케팅",
  items: [
    "기본 홍보: 보도자료, SNS 마케팅",
    "온라인 광고: 네이버, 구글, 페이스북 광고",
    "오프라인 홍보: 서점 이벤트, 북토크",
    "추가 마케팅: 협의 후 추가 투자 가능",
  ],
};

const roleCardsData = [
  {
    title: "출판사의 마케팅 역할",
    items: [
      "전략 수립: 타겟 독자 기반 마케팅 전략",
      "콘텐츠 제작: 홍보 자료 및 카피 제작",
      "채널 관리: 온라인 서점 및 SNS 관리",
      "이벤트 기획: 출판 기념 및 프로모션 이벤트",
    ],
  },
  {
    title: "저작자의 마케팅 역할",
    items: [
      "개인 네트워크: 지인 및 관련 커뮤니티 홍보",
      "콘텐츠 협조: 인터뷰, 기고문 등 제공",
      "이벤트 참여: 북토크, 강연 등 적극 참여",
      "피드백: 마케팅 효과 및 개선사항 공유",
    ],
  },
];

const summaryCardData = {
  items: [
    "기본 마케팅 성과 분석 후 결정",
    "비용 협의: 추가 투자액 및 분담 비율 협의",
    "전략 수정: 시장 반응에 따른 전략 조정",
    "효과 보장: 명확한 목표 설정 후 진행",
  ],
};

const SemiPlannedMarketing = () => {
  return (
    <div className="marketing-info-section">
      <h1 className="section-main-title">
        반기획 출판, 마케팅도 에이콘과 함께!
      </h1>

      <div className="main-promo-card">
        <h2>{mainCardData.title}</h2>
        <div className="main-promo-card-body">
          <h3 className="promo-subtitle">{mainCardData.subtitle}</h3>
          {mainCardData.items.map((item, index) => (
            <p key={index} className="promo-item">
              {item}
            </p>
          ))}
        </div>
      </div>

      <div className="role-cards-grid">
        {roleCardsData.map((card, index) => (
          <div key={index} className="role-card">
            <h3>{card.title}</h3>
            <div className="role-card-body">
              {card.items.map((item, itemIndex) => (
                <p key={itemIndex}>{item}</p>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="summary-card">
        {summaryCardData.items.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </div>
    </div>
  );
};

export default SemiPlannedMarketing;
